'use client';

import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { Language, Theme, PublicUser } from '@glintfans/shared';

export type AuthState = 'checking' | 'guest' | 'authenticated' | 'expired';

interface AppState {
  language: Language;
  theme: Theme;
  user: PublicUser | null;
  authState: AuthState;
  // AUD22: a full-screen form/drawer is open → BottomNav unmounts so it can
  // never cover the form's submit area on mobile.
  fullscreenOpen: boolean;
  setLanguage: (lang: Language) => void;
  setTheme: (theme: Theme) => void;
  setUser: (user: PublicUser | null) => void;
  setAuthState: (state: AuthState) => void;
  setFullscreenOpen: (open: boolean) => void;
}

export const useAppStore = create<AppState>()(
  persist(
    (set) => ({
      language: (() => {
        if (typeof window === 'undefined') return 'en';
        const nav = (navigator.language || '').toLowerCase();
        if (nav.startsWith('zh')) {
          if (nav.includes('tw') || nav.includes('hk') || nav.includes('mo')) return 'zh-Hant';
          return 'zh-Hans';
        }
        return 'en';
      })(),
      theme: 'dark',
      user: null,
      authState: 'checking',
      fullscreenOpen: false,
      setLanguage: (language) => set({ language }),
      setTheme: (theme) => set({ theme }),
      setUser: (user) => set({ user }),
      setAuthState: (authState) => set({ authState }),
      setFullscreenOpen: (fullscreenOpen) => set({ fullscreenOpen }),
    }),
    { name: 'AiLumix-store' },
  ),
);
